import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'
import { RTC_STATE } from "../api/enums.js"
import elm from '../api/element.js'

export default defineStore('userStore', {
	state: () => {
		return {
			userInfo: {},
			isInRtc: false, // 是否正在通话中
			// 角色权限相关(新增)
			roleCode: 'NORMAL', // 用户角色编码
			rolePermissions: null, // 角色权限配置对象
			rolePermissionsLoaded: false, // 权限是否已加载
			isOnlineVisible: true // 在线状态可见性
		}
	},
	actions: {
		setUserInfo(userInfo) {
			this.userInfo = userInfo;
			elm.setTitleTip(undefined, {
				userName: userInfo && userInfo.userName ? userInfo.userName : ''
			});
			// 同步角色信息
			if (userInfo.roleCode) {
				this.roleCode = userInfo.roleCode;
			}
			if (userInfo.isOnlineVisible !== undefined) {
				this.isOnlineVisible = userInfo.isOnlineVisible;
			}
		},
		setInRtc(isInRtc) {
			this.isInRtc = isInRtc;
		},
		setRolePermissions(permissions) {
			this.rolePermissions = permissions;
			this.rolePermissionsLoaded = true;
		},
		setOnlineVisible(visible) {
			this.isOnlineVisible = visible;
		},
		clear() {
			this.userInfo = {};
			elm.setTitleTip('', {
				userName: ''
			});
			this.rtcInfo = {
				friend: {},
				mode: "video",
				state: RTC_STATE.FREE
			};
			// 清空角色权限
			this.roleCode = 'NORMAL';
			this.rolePermissions = null;
			this.rolePermissionsLoaded = false;
			this.isOnlineVisible = true;
		},
		loadUser() {
			return new Promise((resolve, reject) => {
				http({
					url: '/user/self',
					method: 'GET'
				}).then((userInfo) => {
					this.setUserInfo(userInfo);
					resolve();
				}).catch((res) => {
					reject(res);
				});
			})
		},
		loadPermissions() {
			// 加载用户角色权限
			return new Promise((resolve, reject) => {
				http({
					url: '/user/permissions',
					method: 'GET'
				}).then((permissions) => {
					console.log("用户角色权限", permissions);
					this.setRolePermissions(permissions);
					resolve(permissions);
				}).catch((res) => {
					reject(res);
				});
			})
		},
		updateOnlineVisible(visible) {
			// 更新在线状态可见性
			return new Promise((resolve, reject) => {
				http({
					url: `/user/online-visible?enabled=${visible}`,
					method: 'PUT'
				}).then(() => {
					this.setOnlineVisible(visible);
					resolve();
				}).catch((res) => {
					reject(res);
				});
			})
		}
	}
});
